import { axiosPost } from './http';

const prexfix = global.$config.api.apiUrl;
// const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk';
// const prexfix = 'http://222.128.10.58:9009';
// const prexfix = 'http://biaozhunhua.zjht100.com';

// 消息列表查询
export const getMsgList = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizMessage/findPage`, params)
};
// 消息详情
export const getMsgInfo = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizMessage/selectOne`, params)
};
// 首页消息弹窗
export const getMsgPOP = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizMessage/latestData`, params)
};
// 人工处理预警
export const handleMsg = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizMessage/handle`, params)
};

// 人工处理预警
export const saveMsg = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizMessage/save`, params)
};

// 运维平台通用配置
export const getconfigInfo = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/resource-api/resource/sGeneralConfiguration/findAll`, params)
};
// 导入excel文件
export const importExcel = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizPersonOnDuty/import`, params)
};
// 保存值班人
export const saveduty = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizPersonOnDuty/batchSave`, params)
};
// 查询值班人
export const lookduty = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizPersonOnDuty/lastData`, params)
};


// 查询设备
export const queryDevice = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/resDevice/findPage`, params)
};

// 根据预警修改
export const saveBySource = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/data-api/data/data-server/bizMessage/saveBySource`, params)
};


